import { useMemo } from 'react';

function useMergeRefs(refs) {
  return useMemo(() => {
    if (refs.every((ref) => ref == null)) {
      return null;
    }
    return (value) => {
      refs.forEach((ref) => {
        if (typeof ref === "function") {
          ref(value);
        } else if (ref != null) {
          ref.current = value;
        }
      });
    };
  }, refs);
}

export { useMergeRefs as u };
//# sourceMappingURL=useMergeRefs-Bde85AWI-Bde85AWI.js.map
